import React, { useState } from "react";
import { observer } from "mobx-react";

import { useAppStore } from "../../providers/AppStoreProvider";
import { SingleComment } from "./SingleComment";
import { CreateComment } from "./CreateComment";

export const CommentBlock = observer(({ commentBlock }) => {
  const store = useAppStore();
  const [showReply, setShowReply] = useState(false);

  return (
    <div className="comment-block">
      <SingleComment showReply={showReply} comment={commentBlock} onShowReply={setShowReply} />

      <div className="child-comments">
        {commentBlock?.childComments.map((comment, index) => (
          <SingleComment
            key={comment.id}
            showReply={showReply}
            parentId={commentBlock.id}
            comment={comment}
            isChild={true}
            isLastChild={index === commentBlock.childComments?.length - 1}
          />
        ))}
        {showReply && (
          <div
            className="reply-comment comment position-relative"
            style={{ paddingLeft: "4.5rem" }}
          >
            <div className="tree-view-curved position-absolute" />
            {<CreateComment parentId={commentBlock.id} trigger />}
          </div>
        )}
      </div>
    </div>
  );
});
